import React from "react"
import { Alert, Typography } from "antd"

import Markdown from "@components/Markdown"

import useInvalidBankAccountAlert from "./helpers/useInvalidBankAccountAlert"


const InvalidBankAccountAlert = ({
  projects = [],
  bankAccounts = [],
}) => {
  const {
    text,
    onClick,
    shouldRenderAlert,
  } = useInvalidBankAccountAlert(bankAccounts, projects)

  if (!shouldRenderAlert) {
    return null
  }

  const components = {
    a(props) {
      const { children } = props
      return (
        <Typography.Link onClick={onClick}>
          {children}
        </Typography.Link>
      )
    }
  }

  return (
    <div className="header-alerts">
      <Alert
        banner
        message={
          <Markdown
            text={text}
            components={components}
          />
        }
      />
    </div>
  )
}

export default InvalidBankAccountAlert
